const partnerLinks = (state: any) => state.aftermarketPartner.partnerLinks;
const isNTPAccount = (state: any) => state.aftermarketPartner.isNTPAccount;

export const aftermarketPartnerSelectors = {
  partnerLinks,
  isNTPAccount,
};
